<template>
  <div>
    <div
      class="inline-filters small"
      :class="{ 'is-mobile-layout': isMobileLayout, 'is-mobile-show': show }"
    >
      <div :class="isMobileLayout ? 'd-block' : 'd-flex'">
        <div
          v-if="isAdmin"
          class="filter text-input"
          :class="{ 'is-open': focusedFilter === 'title' }"
        >
          <svg-icon icon="search" class="icon text-lighten" />
          <input
            type="text"
            v-model="form['filter[uid]']"
            @focus="focusFilter('title')"
            @blur="unfocusFilter('title')"
            placeholder="User ID"
          />
        </div>
        <div
          class="filter"
          :class="{ 'is-open': focusedFilter === 'statuses' }"
        >
          <multi-select
            :options="selectData.options"
            :select-options="filtersData.statuses"
            @opened="focusFilter('statuses')"
            @closed="unfocusFilter()"
            v-model="form['filter[st]']"
            :btn-label="$tc('status', 2)"
          />
        </div>
        <div class="filter" :class="{ 'is-open': focusedFilter === 'labels' }">
          <multi-select
            :options="selectData.options"
            :select-options="filtersData.labels"
            @opened="focusFilter('labels')"
            @closed="unfocusFilter()"
            v-model="form['filter[ld]']"
            btn-label="Labels"
          />
        </div>
      </div>
    </div>

    <button-fixed-mobile
      :show="isMobileLayout"
      @fixed-button:click="toggleMobileFilters()"
    >
      <svg-icon icon="cross" v-if="show" />
      <svg-icon icon="filter" v-else />
    </button-fixed-mobile>
  </div>
</template>

<script>
import ButtonFixedMobile from '@/components/ButtonFixedMobile.vue';

export default {
  props: {
    isAdmin: {
      type: Boolean,
      default: false
    }
  },

  components: {
    ButtonFixedMobile
  },

  data() {
    return {
      show: false,
      focusedFilter: '',
      selectData: {
        options: {
          multi: true,
          labelName: 'name'
        }
      },
      filtersData: {
        userId: null,
        statuses: ['approved', 'pending', 'rejected'],
        labels: ['Auto-sound', 'Simple images', 'Blinking elements']
      },
      form: {
        'filter[uid]': '',
        'filter[st]': [],
        'filter[lb]': []
      }
    };
  },

  computed: {
    isMobileLayout() {
      return this.$root.screen.xs || this.$root.screen.sm;
    },
    routeName() {
      return this.$router.currentRoute.name;
    }
  },

  methods: {
    focusFilter(val) {
      this.focusedFilter = val;

      // hack()
      setTimeout(() => {
        this.focusedFilter = val;
      }, 100);
    },
    unfocusFilter() {
      this.focusedFilter = '';
    },
    toggleMobileFilters() {
      this.show = !this.show;
    }
  }
};
</script>

<style lang="scss">
.inline-filters {
  max-width: 600px;

  &.small {
    .select > button {
      height: 46px !important;
      line-height: 48px !important;
    }

    .filter.text-input {
      input {
        height: 97%;
        top: 1.5%;
      }

      .icon {
        top: 1.1rem;
      }
    }
  }

  &.is-mobile-layout {
    .filter.text-input {
      input {
        height: 60px;
      }

      .icon {
        top: 1.5rem;
      }
    }
  }
}
</style>
